var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"siimple-footer"},[_c('a',{attrs:{"href":"https://www.sharecoto.co.jp/"}},[_vm._v("sharecoto CO., LTD.")]),_vm._v(" @"+_vm._s(_vm.year)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }